import axios from '@/libs/axios'

export const defaultFilters = () => ({
    merchant_sku: '',
    product_name: '',
    brand_id: '',
    category_id: '',
    has_category: '',
    matched: '',
    in_store: '',
    store_id: '',
    missing_required: '',
    missing_required_attribute_id: '',
    has_batch_error: '',
    batch_store_id: '',
})

export const classificationLabels = {
    missing_category: 'Kategori yok',
    missing_metadata: 'Özellik tanımları eksik',
    incomplete: 'Zorunlu özellikler eksik',
    complete: 'Zorunlu özellikler tamam',
}

export function errorMessage(error) {
    if (error.response && error.response.status === 403) return 'Bu işlem için yetkiniz yok.'
    const body = error.response && error.response.data
    return (body && body.message) || error.message || 'İşlem tamamlanamadı. Lütfen tekrar deneyin.'
}

async function content(request) {
    const { data } = await request
    if (data.status !== 'success') throw new Error(data.message || 'İşlem tamamlanamadı.')
    return data.content
}

export default {
    namespaced: true,
    state: () => ({
        filters: defaultFilters(),
        products: [],
        pagination: null,
        selectedProduct: null,
        listVersion: 0,
        requiredAttributes: [],
    }),
    mutations: {
        setFilters(state, filters) { state.filters = { ...filters } },
        setRequiredAttributes(state, attributes) { state.requiredAttributes = attributes },
        invalidateList(state) { state.listVersion += 1 },
        setProducts(state, result) {
            const { data, ...pagination } = result
            state.products = data
            state.pagination = pagination
        },
        setSelectedProduct(state, product) { state.selectedProduct = product },
        updateProduct(state, product) {
            state.selectedProduct = product
            const index = state.products.findIndex(item => item.id === product.id)
            if (index !== -1) state.products.splice(index, 1, product)
        },
    },
    actions: {
        async loadRequiredAttributes({ commit }) {
            const attributes = await content(axios.get('/v2/trendyol/required-attributes'))
            commit('setRequiredAttributes', attributes)
            return attributes
        },
        async loadProducts({ state, commit }, page = 1) {
            commit('invalidateList')
            const version = state.listVersion
            const { brand_id: brandId, ...filters } = state.filters
            const params = { page, limit: 25 }
            Object.keys(filters).forEach(key => {
                if (filters[key] !== '') params[key] = filters[key]
            })
            if (brandId) params.brand_ids = [Number(brandId)]
            const result = await content(axios.get('/v2/trendyol/products', { params }))
            if (version === state.listVersion) commit('setProducts', result)
            return result
        },
        loadProduct(context, id) {
            return content(axios.get(`/v2/trendyol/products/${id}`))
        },
        async saveProduct({ commit }, { id, payload }) {
            const product = await content(axios.put(`/v2/trendyol/products/${id}/classification`, payload))
            commit('updateProduct', product)
            return product
        },
        loadCategories(context, params) {
            return content(axios.get('/v2/trendyol/categories', { params }))
        },
        loadAttributes(context, categoryId) {
            return content(axios.get(`/v2/trendyol/categories/${categoryId}/attributes`))
        },
        loadValues(context, { categoryId, attributeId, params }) {
            return content(axios.get(`/v2/trendyol/categories/${categoryId}/attributes/${attributeId}/values`, { params }))
        },
    },
}
